import React, { useState, useEffect, useCallback } from "react";
import { Redirect } from 'react-router';
import { FormOutlined, CheckOutlined, CloseOutlined,  DeleteOutlined,EyeOutlined,RollbackOutlined } from "@ant-design/icons";
import {  Icon} from "antd";
import {
    Table,
    Popconfirm,
    Button,
   
} from "antd";
import { Tooltip } from '@material-ui/core';
import moment from "moment";
import "./TablaRegistro.scss";


const EditableContext = React.createContext();






let i=0;
const plColumns = [   
    {
        /*title: (
            <div style={{ textAlign: 'center' }}>
                <div className="filtro">Empresa</div>
                {/*<div className="filtro"><Input style={{ width: '100%' }}/></div>}
            </div>
        ),*/
        title: "No.",
        dataIndex: "key",
        width: "50px",
        editable: false,
        
    },
    {
        /*title: (
            <div style={{ textAlign: 'center' }}>
                <div className="filtro">Empresa</div>
                {/*<div className="filtro"><Input style={{ width: '100%' }}/></div>}
            </div>
        ),*/
        title: "Sexo",
        dataIndex: "sexo",
        width: "100px",
        editable: false,
        render: (text, record) => {
            let splited = text.split("-")
            return splited[1];
        }

    },
    {
        title: "Discapacidad(es)",
        dataIndex: "discapacidad",
        width: "200px",
        editable: false,
        render: (text, record) => {
           let splited;
           return(
            record.discapacidad.map((value, index) => {
                splited = value.split("-")         
                   return (<span>{splited[1]}<br/></span>);
               })
               )
        }
    },
    
  
    {
        title: "Tipo(s) de apoyo para la votación",
        dataIndex: "tipoApoyo",
        width: "300px",
        editable: false,
        render: (text, record) => {
            let splited;
            //console.log("recordd",record, "**", record.key)
            
            return(
             record.tipoApoyo.map((value, index) => {
                 splited = value.split("-")         
                    return (<span>{splited[1]}<br/></span>);
                })
                );
        
        }
         
    }
];


export default function TablaRegistro(props) {
//console.log("TABLA", props)
    const [tableData, setTableData] = useState({
        data: [],
        loadingData: false,
        editingKey: ""
    });
 
    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "",
        idArticulo: -1,
        idTipoDocumentacion: -1,
        nombreArticulo: "",
        nombreEmpresa: "",
        fecha: "",
        tipo: "",
        montos:""
    });

    
    
    const columns = [
        ...plColumns,
        {
            title: "Acciones",
            width: "150px",
            align: "center",
            dataIndex: "operation",
            render: (text, record) => {
                //console.log("Entre en acciones", record)
                //console.log("Entre en acciones1", props)
                return (
                    <div>     {console.log("render acciones")
                    }
             
                                        <Popconfirm
                                            title="¿Está seguro que desea borrar este dato?"
                                            okText="Sí" cancelText="No"
                                            onConfirm={() => remove(record.key)}
                                        >
                                                <Button
                                                    className="boton-accion-circular"
                                                    type="primary"
                                                    shape="circle"
                                                    accept=""
                                                   disabled={props.accion==1?true:false}
                                                    
                                                >
                                                     <Icon type="delete" />
                                                </Button>
                                             </Popconfirm>
                             
                    </div>
                );
            }
        }
    ];

 

  

    function remove(key) {
        //console.log("key", key)
        const newData = [...tableData.data];
        const index = newData.findIndex(item => key === item.key);
        //console.log("Index", index)
        let rowRemove = newData.splice(index, 1);
        //console.log("remove", rowRemove)
        props.handleRemoveData(newData, rowRemove);
        //console.log("Remove", newData, rowRemove)

    }
  


    

 

    useEffect(() => {
        setTableData({
            data: props.data,
            loadingData: true,
            editingKey: ""
        });
       //console.log ("Data tabla****", tableData);
    }, [props.data]);

    // console.log(tableData.data);
    return (
        <div>
           
        <Table
            className="tabla-registro"
            bordered
            dataSource={tableData.data}/**donde recibe del padre la inf a imprimir en pntalla */
            columns={props.accion==1?plColumns:columns}
            scroll={{ x: 240 }}
            rowClassName="editable-row"
        /></div>
    );
}